import { Settings } from "lucide-react"

import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import InsiderPostButton from "./InsiderPostButton"
import { MemberPills } from "./InsiderStates"
import { Panel, SectionHead } from "./Panel"
import { formatDate } from "./format"

function Kv({ label, children }) {
  return (
    <div>
      <div className="mb-[7px] text-[10.5px] font-bold tracking-[0.08em] text-ink-3 uppercase">{label}</div>
      <div className="text-[14px] font-semibold text-foreground tabular-nums">{children}</div>
    </div>
  )
}

// The member "Manage subscription" card: real status and dates from the
// presenter, and a button that POSTs to the Stripe Billing Portal
// (endpoints.portal). Shown for the member and welcome states.
export default function ManageCard({ subscription, endpoints }) {
  if (!subscription) return null
  const cancels = subscription.cancelAtPeriodEnd

  return (
    <>
      <SectionHead eyebrow="Manage" title="Your Insider subscription" />
      <Panel>
        <div className="flex flex-wrap items-center gap-x-[30px] gap-y-[20px] px-[22px] py-[20px]">
          <div className="grid min-w-[280px] flex-1 grid-cols-3 gap-[16px] max-[561px]:grid-cols-2">
            <Kv label="Status">
              <MemberPills subscription={subscription} />
            </Kv>
            <Kv label="Active since">{formatDate(subscription.activeSince) ?? "—"}</Kv>
            <Kv label={cancels ? "Ends on" : "Next billing"}>{formatDate(subscription.nextBilling) ?? "—"}</Kv>
          </div>
          <div className="flex w-[260px] flex-col gap-[10px] max-[861px]:w-full">
            <p className="text-[12.5px] leading-[1.5] text-ink-3">
              Update payment, change billing details, or cancel from the Stripe portal.
            </p>
            <InsiderPostButton
              action={endpoints?.portal}
              formClassName="block"
              className={cn(buttonVariants({ variant: "outline" }), "h-auto w-full px-[15px] py-[9px] text-[13px] font-semibold")}
            >
              <Settings strokeWidth={2} />
              Manage subscription
            </InsiderPostButton>
          </div>
        </div>
        <div className="mx-[22px] mb-[20px] rounded-[10px] border border-needs-you/25 bg-needs-you/10 px-[15px] py-[13px] text-[12.5px] leading-[1.55] text-muted-foreground">
          <b className="text-needs-you">Heads up:</b> Insider is a one-time membership. If you cancel, you won&apos;t be
          able to resubscribe and your locked-in rates will be lost permanently.
        </div>
      </Panel>
    </>
  )
}
